'use client'
import Link from 'next/link'
import { Menu, X } from 'lucide-react'
import { useState } from 'react'

const indiaNavigation = [
  { name: 'About', href: '/india/about' },
  { name: 'Team', href: '/india/team' },
  { name: 'Mentors', href: '/india/mentors' },
  { name: 'Partner', href: '/india/partners' },
  { name: 'Portfolio', href: '/india/portfolio' },
  { name: 'Events', href: '/india/events' },
]

export default function IndiaNavbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="relative z-20 border-b border-slate-800/50">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
        <div className="flex items-end">
          <Link href="/india" className="-m-1.5 p-1.5">
            <img
              src="/images/home/ai-forge-india-logo.png"
              className="h-[52px] md:h-[62px] w-auto"
              alt="AI Forge India Logo"
            />
          </Link>
        </div>

        {/* Mobile menu button */}
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="sr-only">Open main menu</span>
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Desktop navigation */}
        <div className="hidden lg:flex lg:gap-x-8">
          {indiaNavigation.map((item) => (
            <Link
              key={item.name}
              href={item.href}
              className="text-sm font-semibold leading-6 text-white hover:text-orange-400 transition"
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* Apply button */}
        <div className="hidden lg:flex lg:justify-end">
          <Link
            href="https://www.aiforge.org/signup?role=founder"
            className="px-5 py-2.5 rounded-full bg-orange-500 text-white hover:bg-orange-600 font-semibold text-sm transition"
          >
            Apply For India Cohort One
          </Link>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-gray-900/95 border-t border-slate-800">
          <div className="px-6 py-4 space-y-2">
            {indiaNavigation.map((item) => (
              <Link
                key={item.name}
                href={item.href}
                onClick={() => setMobileMenuOpen(false)}
                className="block py-2 text-base font-semibold text-white hover:text-orange-400"
              >
                {item.name}
              </Link>
            ))}
            <Link
              href="https://www.aiforge.org/signup?role=founder"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 text-base font-semibold text-orange-500"
            >
              Apply For India Cohort One
            </Link>
          </div>
        </div>
      )}
    </header>
  )
}
